// Libraries
import React, { useState } from "react";
import Dropzone from "react-dropzone";

const DragDrop = ({ onChange }) => {
  const [files, setFiles] = useState([]);

  // On Drop Event Handler
  const onDrop = (acceptedFiles) => {
    setFiles((files) => files.concat(...acceptedFiles));
    onChange(acceptedFiles);
  };

  // Remove Event Hanlder
  // const handleClick = (e) => {
  //   console.log(e.target.parentNode);
  // };

  return (
    <Dropzone onDrop={onDrop}>
      {({ getRootProps, getInputProps }) => (
        <section className="drag-drop-section">
          <div {...getRootProps()} className="drag-drop-div">
            <input {...getInputProps()} />
            <p className="drag-drop-text py-4 ">
              Drag ‘N’ Drop a File, or multiple Files here...
            </p>
          </div>

          <div className="px-2 py-2">
            {files.map((file) => (
              <div id={file.size} className="drag-drop-file my-2">
                {file.path}{" "}
                {/* <a id={file.path} href="#" onClick={(e) => handleClick(e)}>
                  <i
                    className="fa fa-times-circle"
                    aria-hidden="true"
                    style={{ verticalAlign: "unset" }}
                  ></i>
                </a> */}
              </div>
            ))}
          </div>
        </section>
      )}
    </Dropzone>
  );
};

export default DragDrop;
